import { useNavigate } from "react-router-dom";
import classes from "./GetAQuoteButton.module.css";

export default function GetAQuoteButton({ sku, text = "Get a Quote" }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!sku) return;
    navigate("/contact", { state: { sku } });
  };

  return (
    <button className={classes.quoteButton} onClick={handleClick}>
      {text}
    </button>
  );
}
